import logoSimio from "../assets/favicon.png";
import logoApi from "../assets/logoApi.png";
import klaviyo from "../assets/logoKlaviyo.png";
import shopify from "../assets/logoShopify.svg";
import splio from "../assets/logoSplio.jpeg";
import batch from "../assets/logoBatch.png";
import just from "../assets/logoJust.png";
import { Badge } from "../externalComponents/tailwind/badge";
import { Text } from "../externalComponents/tailwind/text";

function AutomationTriggerNode({ id, data }) {
  const triggers = {
    "abandoned-cart": {
      title: "Abandoned checkout",
      description:
        "Flow starts when a customer has started a checkout, if no order is placed, after a delay of",
      logo: shopify,
      type: "abandoned-cart",
    },
    "just-abandoned-checkout": {
      title: "Abandoned checkout",
      description:
        "Flow starts when a customer has started a checkout, if no order is placed, after a delay of",
      logo: just,
      type: "just-abandoned-checkout",
    },
    "order-confirmation": {
      title: "Order paid",
      description: "Flow starts when an order is processed",
      logo: shopify,
      type: "order-confirmation",
    },
    "order-tracking": {
      title: "Order shipped",
      description: "Flow starts when an order is fulfilled",
      logo: shopify,
      type: "order-tracking",
    },
    "back-in-stock": {
      title: "Back in stock",
      description: "Flow starts when a product inventory quantity becomes > 2",
      logo: shopify,
      type: "back-in-stock",
    },
    "optin-confirmation": {
      title: "Optin confirmation",
      description: "Flow starts when a customer has optin for the first time",
      logo: logoSimio,
      type: "optin-confirmation",
    },
    api: {
      title: "API",
      description: "Flow starts when an API request is made",
      logo: logoApi,
      type: "api",
    },
    klaviyo: {
      title: "Flow webhook",
      description:
        "Flow starts when a webhook request is made in a Klaviyo flow",
      logo: klaviyo,
      type: "klaviyo",
    },
    splio: {
      title: "Flow webhook",
      description: "Flow starts when a webhook request is made in a Splio flow",
      logo: splio,
      type: "splio",
    },
    batch: {
      title: "Batch",
      description: "Flow starts whenever you want in a Batch Flow",
      logo: batch,
      type: "batch",
    },
  };

  let hours = 0;
  let minutes = 0;
  if (data.abandonedCartDelayInMinutes) {
    hours = Math.floor(data.abandonedCartDelayInMinutes / 60);
    minutes = data.abandonedCartDelayInMinutes - 60 * hours;
  }

  return (
    <div
      className={"automation-trigger-node"}
      onClick={() => data.clickNode(id)}
    >
      <div className="flex justify-center items-center flex-col p-2">
        <img
          src={triggers[data.type].logo}
          alt="logo du trigger"
          className="mx-auto h-14 w-14 object-cover"
        />
        <Text className="text-base mb-3">{triggers[data.type].title}</Text>
        <Text className="text-xs">{triggers[data.type].description}</Text>
        {(data.type === "abandoned-cart" ||
          data.type === "just-abandoned-checkout") && (
          <Badge color="violet" className="mt-1">
            {hours > 0 ? `${hours} hour${hours > 1 ? "s" : ""}` : ""}
            {hours > 0 && minutes > 0 ? ` and ` : ""}
            {minutes > 0 ? `${minutes} minute${minutes > 1 ? "s" : ""}` : ""}
          </Badge>
        )}
      </div>
    </div>
  );
}

export default AutomationTriggerNode;
